import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { SlideMenu } from 'primereact/slidemenu';
import { useHistory } from "react-router-dom";


export const AppTopbar = (props) => {

    const user_connect_local = localStorage.getItem("user_connect");
    const user_connect = JSON.parse(user_connect_local);
    const menu = useRef(null);
    const navigate = useHistory();


    const logout = () => {
        localStorage.removeItem("auth");
        navigate.push('/login');
    }

    const items = [
        {
            label: 'Déconnexion',
            icon: 'pi pi-fw pi-power-off',
            command: () => {
                logout();
                window.location.hash = "/login";
                window.location.reload(true);
                localStorage.removeItem("user_connect");
                localStorage.removeItem("auth")

            }


        },

        {
            label: 'Profile',
            icon: 'pi pi-user',
            command: () => {
                window.location.hash = "/profile";

            }


        }
    ]

    return (
        <div className="layout-topbar">
            <Link to="/dashboard" className="layout-topbar-logo">
                <img src={props.layoutColorMode === 'light' ? 'assets/layout/images/favicon.ico' : 'assets/layout/images/favicon.png'} alt="logo" />
                <span>WEBLAMPS</span>
            </Link>

            <button type="button" className="p-link  layout-menu-button layout-topbar-button" onClick={props.onToggleMenuClick}>
                <i className="pi pi-bars" />
            </button>

            <button type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={props.onMobileTopbarMenuClick}>
                <i className="pi pi-ellipsis-v" />
            </button>

            <ul className={classNames("layout-topbar-menu lg:flex origin-top", { 'layout-topbar-menu-mobile-active': props.mobileTopbarMenuActive })}>
                {/* <li>
                    <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                        <i className="pi pi-calendar" />
                        <span>Events</span>
                    </button>
                </li> */}
                {/* <li>
                    <button className="p-link layout-topbar-button" onClick={props.onMobileSubTopbarMenuClick}>
                        <i className="pi pi-cog" />
                        <span>Settings</span>
                    </button>
                </li> */}
                <Link to="/dashboard" className='mr-5'>
                    <i className="pi pi-home" />

                </Link>
                <Link to="/#" className='mr-5' >
                    <i className="pi pi-cog" />

                </Link>
                <li>
                    <SlideMenu className="p-link layout-topbar-button" ref={menu} model={items} popup viewportHeight={100}></SlideMenu>
                    <button type='button' className="p-link" onClick={(event) => menu.current.toggle(event)} >
                        <i className="pi pi-user" />
                        {`   ${user_connect.prenom} ${user_connect.nom}`}
                    </button>
                </li>
            </ul>
        </div>
    );
}
